import React from "react";
import About from "./about";
import Main from "./main";
import Subjects from "./subjects";
import Facilities from "./facilities";
import Events from "./events";
import Questions from "./questions/index";
import Teachers from "./topTeachers";
import Students from "./topStudents";
import Reviews from "./reviews";
import Contact from "./contact";
import Navbar from "../shared/layout/header";
import Footer from "../shared/layout/footer";
import Top from "../shared/components/Top";
import ExtraCurriculars from "./extraCurricular";

const Home = () => {
  return (
    <div>
      <Navbar />
      <Main />
      <About />
      <Subjects />
      <Facilities />
      <Events />
      <Questions />
      <Teachers />
      <Students />
      <ExtraCurriculars />
      <Reviews />
      <Contact />
      <Top />
      <Footer />
    </div>
  );
};

export default Home;
